import { Box } from '@mui/material';
import { ResponsiveLine } from '@nivo/line';
import ChartSection from '../shared/ChartSection';
import ChartTooltip from '../shared/ChartTooltip';
import useNivoTheme from '../shared/useNivoTheme';

export default function CallsVsPuts({ data }) {
    const { theme, colors } = useNivoTheme();
    if (!data || data.length === 0) return null;

    // Puts listed first so red matches "Puts (Bearish)" and green matches "Calls (Bullish)".
    const lineData = [
        { id: 'Puts (Bearish)', data: data.map(d => ({ x: d.month, y: d.puts })) },
        { id: 'Calls (Bullish)', data: data.map(d => ({ x: d.month, y: d.calls })) },
    ];

    return (
        <ChartSection
            id="calls-puts"
            title="Is Congress getting more bullish or bearish on options?"
            subtitle="Call option volume (bullish bets) vs put option volume (bearish bets) over time"
        >
            <Box sx={{ height: 320 }}>
                <ResponsiveLine
                    data={lineData}
                    margin={{ top: 20, right: 130, bottom: 60, left: 55 }}
                    xScale={{ type: 'point' }}
                    yScale={{ type: 'linear', min: 0, max: 'auto' }}
                    curve="monotoneX"
                    enablePoints={false}
                    enableGridX={false}
                    colors={[colors.error, colors.success]}
                    lineWidth={2}
                    axisBottom={{
                        tickRotation: 45,
                        tickValues: data.filter((_, i) => i % 12 === 0).map(d => d.month),
                    }}
                    axisLeft={{
                        legend: 'Contracts',
                        legendPosition: 'middle',
                        legendOffset: -45,
                    }}
                    legends={[
                        {
                            anchor: 'top-right',
                            direction: 'column',
                            translateX: 110,
                            itemWidth: 100,
                            itemHeight: 20,
                            symbolSize: 8,
                            itemTextColor: '#9ca3af',
                        },
                    ]}
                    enableSlices="x"
                    sliceTooltip={({ slice }) => (
                        <ChartTooltip
                            title={String(slice.points[0].data.x)}
                            rows={slice.points.map(p => ({
                                label: p.seriesId,
                                value: Number(p.data.y).toLocaleString() + ' contracts',
                                color: p.seriesColor,
                            }))}
                        />
                    )}
                    theme={theme}
                />
            </Box>
        </ChartSection>
    );
}
